import AssistantIcon from '@material-ui/icons/Assistant';
import { CustomBreadcrumbs } from 'candy-commons-components';
import React from 'react';
import { Create, SimpleForm, useTranslate } from 'react-admin';
import NewFeaturesBannerFields, {
    prepareBannerFormData,
} from './NewFeaturesBannerFields';

const NewFeaturesBannerCreate = (props) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.new-features-banner.name'),
            url: 'new-features-banner',
            icon: <AssistantIcon />,
        },
        {
            text: translation('resources.new-features-banner.create.name'),
            url: '',
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props} transform={prepareBannerFormData}>
                <SimpleForm>
                    <NewFeaturesBannerFields />
                </SimpleForm>
            </Create>
        </>
    );
};
export default NewFeaturesBannerCreate;
